var qt=Object.defineProperty;var rt=g=>{throw TypeError(g)};var Lt=(g,b,t)=>b in g?qt(g,b,{enumerable:!0,configurable:!0,writable:!0,value:t}):g[b]=t;var F=(g,b,t)=>Lt(g,typeof b!="symbol"?b+"":b,t),B=(g,b,t)=>b.has(g)||rt("Cannot "+t);var U=(g,b,t)=>(B(g,b,"read from private field"),t?t.call(g):b.get(g)),$=(g,b,t)=>b.has(g)?rt("Cannot add the same private member more than once"):b instanceof WeakSet?b.add(g):b.set(g,t),R=(g,b,t,i)=>(B(g,b,"write to private field"),i?i.call(g,t):b.set(g,t),t),c=(g,b,t)=>(B(g,b,"access private method"),t);import{LitElement as Tt,css as Mt,html as _,unsafeHTML as I}from"https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js";import{f as k}from"./uwp.currency.ZSKpVHj0.js";class G extends Tt{constructor(){var t;super();F(this,"fetchProduct",t=>fetch(`/products/${t}.js`).then(i=>i.json()).then(i=>(this.product=i,this.selectedVariant=i.variants[0],i)));this.currency=window.Shopify.currency.active||"USD",this.language=window.Shopify.locale||"en-US",this.moneyFormatter=new Intl.NumberFormat(this.language,{style:"currency",currency:this.currency,minimumFractionDigits:2,maximumFractionDigits:2}),this.debug=(t=window==null?void 0:window.Shopify)==null?void 0:t.designMode,this.variantChanged=!1,this.rules=[],this.rule=null,this.quantity=1,this.showDetailsHover=!1}async connectedCallback(){super.connectedCallback(),this.log("Mounted",{label:this.activatorLabel,content:this.subscriptionTooltipText}),this.productHandle&&(this.loading=!0,this.fetchProduct(this.productHandle)),this.bindFormEvents(),this.bindCartEvents(),this.rules=await this.fetchRules(),await this.getRule()}radioTemplate(){return _`
      <div class="skio-radio__container">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="1"
          ></circle>
          <circle
            class="skio-radio"
            cx="12"
            cy="12"
            r="7"
            fill="currentColor"
          ></circle>
        </svg>
      </div>
    `}sellingPlanDropdown(t){return _`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(t).length==1?"selling-plan-dropdown--one":""}"
        @change=${i=>{this.selectSellingPlan(i.target.value)}}
      >
        ${t?this.getAvailableSellingPlans(t).map(i=>_`
                <option
                  ?selected=${t.selected_selling_plan.id===i.id}
                  value=${i.id}
                >
                  ${i.name}
                </option>
              `):""}
      </select>
    `}sellingPlanButtons(t){return _`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${t?this.getAvailableSellingPlans(t).map(i=>_`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${i}"
                  id="selling_plan_button-${i.id}"
                  @change="${e=>this.selectSellingPlan(i.id)}"
                  ?checked=${t.selected_selling_plan===i}
                />

                <label for="selling_plan_button-${i.id}">
                  ${i.name}
                </label>
              `):""}
      </fieldset>
    `}invalidIcon(){return _`
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#D22B2B"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    `}validIcon(){return _`
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#0BDA51"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    `}setupMode(){return _`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">
          ${this.product?this.validIcon():this.invalidIcon()} Product
        </div>

        <div class="detection">
          ${this.selectedVariant?this.validIcon():this.invalidIcon()}
          Selected Variant
        </div>

        <div class="detection">
          ${this.form?this.validIcon():this.invalidIcon()} Form
        </div>

        <div class="detection">
          ${this.variantInput?this.validIcon():this.invalidIcon()} Variant
          Input
        </div>

        <div class="detection">
          ${this.variantChanged?this.validIcon():this.invalidIcon()} Variant
          Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small
          >If any of these don't pass please troubleshoot using our
          <a
            target="_blank"
            rel="noreferrer"
            href="https://integrate.skio.com/troubleshooting"
            >troubleshooting guide</a
          >.</small
        >
      </div>
    `}groupContent(t){var i,e,s,n,l;return _`
      <div
        class="group-content ${((i=this.options)==null?void 0:i.layout)=="horizontal"?"":(e=this.options)!=null&&e.show_radio_selector&&((s=this.options)==null?void 0:s.dropdownPosition)=="inside"?"margin-left":""}"
      >
        <span class="selling-plan-dropdown-label"
          >${this.additionalFrequencyLabel()}</span
        >
        ${((n=this.options)==null?void 0:n.selector_type)=="dropdown"?this.sellingPlanDropdown(t):""}

        <!-- TODO: Make the label have the border instead of the group -->
        ${((l=this.options)==null?void 0:l.selector_type)=="button"?this.sellingPlanButtons(t):""}
        ${this.additionalContentText()}
      </div>
    `}renderDrawerContent(){const t=document.createElement("div");return t.innerHTML=this.subscriptionTooltipText,t.classList.add("rte"),this.subscriptionTooltipText!=="false"?_`${t}`:_`
          <ul>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it’s not for you</small>
              </div>
            </li>
          </ul>
        `}showDetails(){return _`
      <details
        class="skio-details"
        @mouseover=${t=>this.detailsMouseover()}
        @mouseleave=${t=>this.detailsMouseleave()}
      >
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            ${this.activatorLabel}
          </span>
        </summary>
        <div class="skio-details--content">
          ${this.renderDrawerContent()}
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login"
              >Manage subscriptions</a
            >

            <a
              style="letter-spacing: 0"
              class="powered-by-skio"
              href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover"
              target="_blank"
              rel="noopener"
            >
              Powered by
              <svg
                width="24"
                height="11"
                viewBox="0 0 24 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path
                  d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z"
                  fill="black"
                />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `}render(){var t,i,e,s,n,l,o,r,a,d,u,f,y;return!this.viable()||((t=this.options)==null?void 0:t.layout)==="hidden"?this.debug?this.setupMode():"":this.selectedVariant.selling_plan_allocations.length===0&&!((i=this.options)!=null&&i.show_without_subscription)?this.debug?this.setupMode():"":_`
      ${this.debug?this.setupMode():null}

      <fieldset
        class="skio-plan-picker"
        role="radiogroup"
        aria-labelledby="skio-plan-picker-legend"
      >
        <legend
          id="skio-plan-picker-legend"
          class="${(e=this.options)!=null&&e.show_legend?"":"sr-only"}"
        >
          ${I((s=this.options)==null?void 0:s.legend_content)}
        </legend>

        ${this.product.requires_selling_plan?"":_`
              <div
                class="group-container ${this.selectedSellingPlanGroup==null?"group-container--selected":""} ${(n=this.options)!=null&&n.onetime_first?"":"group-container--last"}"
                @click=${()=>this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${()=>this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${((l=this.options)==null?void 0:l.layout)=="horizontal"?"":(o=this.options)!=null&&o.show_radio_selector?this.radioTemplate():""}

                    <div class="group-title">
                      ${(r=this.options)!=null&&r.onetime_title?(a=this.options)==null?void 0:a.onetime_title:"One time purchase"}
                    </div>

                    <div class="skio-price" aria-live="polite">
                      ${(d=this.options)!=null&&d.show_compare_price&&((u=this.selectedVariant)==null?void 0:u.compare_at_price)>this.selectedVariant.price?_`<s aria-hidden="true"
                            >${this.money(this.selectedVariant.compare_at_price)}</s
                          >`:""}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                </label>
              </div>
            `}
        ${(f=this.availableSellingPlanGroups)!=null&&f.length?this.availableSellingPlanGroups.map((m,v)=>{var S,w,P,x,C,L,T,M,it,st,nt,lt,ot;return _`
                <div
                  class="group-container ${this.selectedSellingPlanGroup==m?"group-container--selected":""}"
                >
                  <input
                    id="group-${v}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${m.id}"
                    @change=${()=>this.selectSellingPlanGroup(m)}
                    ?checked=${this.selectedSellingPlanGroup==m}
                  />

                  <label class="group-label" for="group-${v}-${this.key}">
                    <div class="group-topline">
                      ${((S=this.options)==null?void 0:S.layout)=="horizontal"?"":(w=this.options)!=null&&w.show_radio_selector?this.radioTemplate():""}

                      <div class="group-title">
                        ${m.name!=="Prepaid"&&((P=this.options)!=null&&P.subscription_title)?(x=this.options)==null?void 0:x.subscription_title:m.name=="Prepaid"&&((C=this.options)!=null&&C.prepaid_title)?(L=this.options)==null?void 0:L.prepaid_title:m.name}
                        ${this.discountText(m.selected_selling_plan)?_`
                              <span
                                class="savings ${(T=this.options)==null?void 0:T.discount_style}"
                              >
                                ${this.discountText(m.selected_selling_plan)}
                              </span>
                            `:_``}
                      </div>

                      <div class="skio-price" aria-live="polite">
                        ${(M=this.options)!=null&&M.show_compare_price&&(((it=this.selectedVariant)==null?void 0:it.compare_at_price)>this.selectedVariant.price||this.selectedVariant.price>this.price(m.selected_selling_plan,!1))?_`<s aria-hidden="true"
                              >${this.money(this.selectedVariant.compare_at_price?this.selectedVariant.compare_at_price:this.selectedVariant.price)}</s
                            >`:""}
                        ${this.price(m.selected_selling_plan)}
                        ${this.postCheckoutDiscountsText(m.selected_selling_plan)}
                      </div>
                    </div>

                    ${((st=this.options)==null?void 0:st.layout)=="vertical"&&((nt=this.options)==null?void 0:nt.dropdownPosition)=="inside"?this.groupContent(m):""}
                  </label>
                </div>
                ${this.selectedSellingPlanGroup==m&&(((lt=this.options)==null?void 0:lt.layout)=="horizontal"||((ot=this.options)==null?void 0:ot.dropdownPosition)=="underneath")?this.groupContent(m):""}
              `}):""}
        ${((y=this.options)==null?void 0:y.show_details)==!0?this.showDetails():""}
      </fieldset>
    `}async fetchRules(){var t;if(sessionStorage.getItem("skio-discount-rules"))return JSON.parse(sessionStorage.getItem("skio-discount-rules"));{const i=await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${(t=window==null?void 0:window.Shopify)==null?void 0:t.shop}`).then(e=>e.json()).then(e=>e.rules.filter(s=>s.type!=="surpriseDelight").sort((s,n)=>s.minQuantityToDiscount-n.minQuantityToDiscount));return sessionStorage.setItem("skio-discount-rules",JSON.stringify(i)),i}}eligibleItemCount(t){var e,s;return(e=this.cart)!=null&&e.items?Number((s=this.cart)==null?void 0:s.items.reduce((n,l)=>t!=null&&t.productVariantIds.some(o=>o.includes(l.id)&&l.selling_plan_allocation)?n+l.quantity:n,0))+this.quantity:this.quantity}getRule(){let t={value:-1,index:-1};this.rules.forEach((i,e)=>{i.code&&t.value<i.minQuantityToDiscount&&i.minQuantityToDiscount<=this.eligibleItemCount(i)&&(t.value=i.minQuantityToDiscount,t.index=e)}),this.rule=t.index>-1?this.rules[t.index]:null}bindCartEvents(){document.addEventListener("CartUpdated",t=>{this.cart=t.detail})}bindFormEvents(){var t;this.form=document.querySelector(`#${(t=this.options)==null?void 0:t.form_id}`)||this.closest('form[action*="/cart/add"]'),this.form&&(this.variantInput=this.form.querySelector('[name*="id"]'),this.variantInput&&this.variantInput.addEventListener("change",i=>{this.selectedVariant=this.product.variants.find(e=>e.id==i.target.value),this.variantChanged=!0}))}detailsMouseover(){let t=this.renderRoot.querySelector(".skio-details"),i=this.renderRoot.querySelector(".skio-details summary");!t.hasAttribute("open")&&this.showDetailsHover==!1&&(i.click(),this.showDetailsHover=!0)}detailsMouseleave(){let t=this.renderRoot.querySelector(".skio-details"),i=this.renderRoot.querySelector(".skio-details summary");t.hasAttribute("open")&&this.showDetailsHover==!0&&(i.click(),this.showDetailsHover=!1)}updated(t){var i,e,s,n,l;if(this.viable()){if(t.has("product")&&this.product&&(this.key=this.key?this.key:this.product.id),t.has("selectedVariant")&&this.selectedVariant){const o=this.product.selling_plan_groups.filter(r=>r.app_id==="SKIO"&&!r.name.toLowerCase().includes("hidden-")&&!r.name.toLowerCase().includes("dynamic box subscription"));if(this.availableSellingPlanGroups=o.filter(r=>r.selling_plans.some(a=>this.selectedVariant.selling_plan_allocations.some(d=>d.selling_plan_id===a.id))),(i=this.options)!=null&&i.combine_groups&&(this.availableSellingPlanGroups=[{name:(e=this.options)==null?void 0:e.combined_group_name,selling_plans:this.availableSellingPlanGroups.flatMap(r=>r.selling_plans),id:"combined_group",app_id:"SKIO"}]),(s=this.availableSellingPlanGroups)!=null&&s.length){const a=new URL(window.location.href).searchParams.get("selling_plan");if(this.availableSellingPlanGroups.forEach(d=>{var S;const u=this.getAvailableSellingPlans(d),f=u.find(w=>w.id==a),y=u.find(w=>{var P;return w.name===((P=this.selectedSellingPlan)==null?void 0:P.name)}),m=(S=this.options)!=null&&S.default_subscription&&this.options.default_subscription.trim()!==""?u.find(w=>w.name.toLowerCase().includes(this.options.default_subscription.toLowerCase())):null;d.selected_selling_plan=f||y||m||u[0];const v=f||y||m;d.selected=!!v}),!this.variantChanged&&((n=this.options)==null?void 0:n.start_onetime)==!1||this.product.requires_selling_plan==!0||a||this.selectedSellingPlan){let u=(this.availableSellingPlanGroups.find(f=>f.selected)||this.availableSellingPlanGroups[0]).selected_selling_plan.id;this.selectSellingPlan(u)}else this.selectSellingPlanGroup(null)}else this.selectSellingPlanGroup(null)}if(t.has("selectedSellingPlan")){this.selectedSellingPlan?this.updateLineItemProperty(!0):this.updateLineItemProperty(!1);const o=new CustomEvent("skio::update-selling-plan",{bubbles:!0,composed:!0,detail:{variant:this.selectedVariant,sellingPlan:this.selectedSellingPlan,key:this.key}});this.dispatchEvent(o),this.dispatchEvent(new CustomEvent("change",{detail:{value:(l=this.selectedSellingPlan)==null?void 0:l.id}}))}this.updateForm(),this.updateExternalPrice(),this.disableUrl||this.updateURLParams(),t.has("quantity")&&this.getRule(),t.has("cart")&&this.getRule(),this.updateExternalElements()}}updateLineItemProperty(t){const i=document.querySelector('input[name="properties[_is_subscription]"]');i&&(i.value=t)}updateExternalElements(){document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(t=>{t.innerHTML=this.price(this.selectedSellingPlan)}),document.querySelectorAll("[skio-subscription-content]").forEach(t=>{t.style.display=this.selectedSellingPlan?"block":"none"})}log(...t){t.unshift(`%c[skio plan picker][${this.key}]`,"color: #8770f2;"),console.log.apply(console,t)}error(...t){t.unshift(`%c [skio plan picker][${this.key}]`,"color: #ff0000"),console.error.apply(console,t)}appendOrdinalSuffix(t){const i=t%10,e=t%100;return i==1&&e!=11?t+"st":i==2&&e!=12?t+"nd":i==3&&e!=13?t+"rd":t+"th"}money(t){return this.moneyFormatter.format(t/100)}viable(){const t=[];return this.querySelector("input[name=selling_plan]")||t.push("Missing selling plan input"),this.product||t.push("No product found. Please pass a product or productHandle to the skio-plan-picker component."),this.selectedVariant||t.push("No variant found. Please pass a product or productHandle to the skio-plan-picker component."),this.form||t.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".'),this.variantInput||t.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"'),t.length==0?!0:(this.error("Errors",t),!1)}getAvailableSellingPlans(t){return t.selling_plans.filter(e=>this.selectedVariant.selling_plan_allocations.some(s=>s.selling_plan_id===e.id))}selectSellingPlanGroup(t){this.selectedSellingPlanGroup=t,this.selectedSellingPlan=t==null?void 0:t.selected_selling_plan}selectSellingPlan(t){const i=this.availableSellingPlanGroups.find(s=>s.selling_plans.some(n=>n.id==t)),e=i.selling_plans.find(s=>s.id==t);i.selected_selling_plan=e,this.selectedSellingPlanGroup=i,this.selectedSellingPlan=e}updateExternalPrice(){var t,i;document.querySelectorAll((t=this.options)==null?void 0:t.external_price_selector).forEach(e=>{this.selectedSellingPlan?e.innerHTML=this.price(this.selectedSellingPlan):e.innerHTML=this.money(this.selectedVariant.price)}),document.querySelectorAll((i=this.options)==null?void 0:i.external_price_selector).forEach(e=>{this.selectedSellingPlan?e.innerHTML=this.price(this.selectedSellingPlan)+" "+this.currency:e.innerHTML=this.money(this.selectedVariant.price)+" "+this.currency})}additionalFrequencyLabel(){var t,i,e;if(!(!((t=this.options)!=null&&t.additional_frequency_label)||((i=this.options)==null?void 0:i.additional_frequency_label)==""))return I((e=this.options)==null?void 0:e.additional_frequency_label)}additionalContentText(){var t,i,e,s;if(!(!((t=this.options)!=null&&t.additional_subscription_content)||((i=this.options)==null?void 0:i.additional_subscription_content)==""))return I((s=this.options)==null?void 0:s.additional_subscription_content.replaceAll("[discount]",((e=this.options)==null?void 0:e.discount_format)==="absolute"?this.money(this.discount(this.selectedSellingPlan).absolute):this.discount(this.selectedSellingPlan).percent+"%").replaceAll("[future_price_adjustments]",this.postCheckoutDiscountsText(this.selectedSellingPlan)||""))}discountText(t){var s,n,l;const i=this.discount(t);return Object.values(i).some(o=>o===0||o===1/0||o.toString().includes("-"))?"":(console.log("OPTIONS",this.options),console.log("DISCOUNT TEXT",(s=this.options)==null?void 0:s.discount_text),I((l=this.options)==null?void 0:l.discount_text.replaceAll("[discount]",((n=this.options)==null?void 0:n.discount_format)==="absolute"?this.money(i.absolute):i.percent+"%").replaceAll("[future_price_adjustments]",this.postCheckoutDiscountsText(t)||"")))}discount(t){return t?this.getDiscountFromPriceAdjustment(t,t.price_adjustments[0]):{percent:0,amount:0}}postCheckoutPriceAdjustments(t){const{price_adjustments:i}=t;return i.filter(({position:n})=>n!==1).map(n=>this.getDiscountFromPriceAdjustment(t,n))}postCheckoutDiscountsText(t=this.selectedSellingPlan){var e;if(!t||!((e=this.options)!=null&&e.future_price_adjustments_text)||this.future_price_adjustments_text=="")return;const i=this.postCheckoutPriceAdjustments(t);if(i.length)return i.map((s,n)=>{var l,o;return I((o=this.options)==null?void 0:o.future_price_adjustments_text.replaceAll("[price]",this.money(Math.round(this.price(t,!1)-s.amount))).replaceAll("[discount]",((l=this.options)==null?void 0:l.discount_format)==="absolute"?this.money(s.absolute):s.percent+"%").replaceAll("[order_count]",n+1).replaceAll("[order_count_ordinal]",this.appendOrdinalSuffix(n+1)))})}getDiscountFromPriceAdjustment(t,i){const e={percent:0,amount:0,absolute:0};let s=1,n=this.product.selling_plan_groups.find(r=>r.selling_plans.some(a=>a.id==t.id));if((n==null?void 0:n.name)==="Prepaid"){const r=t.name,a=/\b\d+\s*(days|weeks|months|years)\b/gi,d=r.match(a);if(d!=null&&d.length){const u=d[0].match(/\d+/g);s=u[0]/(u[1]||1),s=s>1?s:1}}const l=this.selectedVariant.price,o=this.selectedVariant.compare_at_price&&this.selectedVariant.compare_at_price>l?this.selectedVariant.compare_at_price:l;switch(i.value_type){case"percentage":e.percent=i.value,e.absolute=Math.round(l*i.value/100),e.amount=Math.round(l*i.value/100);break;case"fixed_amount":e.percent=Math.round(i.value*1/l*100),e.absolute=i.value,e.amount=i.value;break;case"price":e.percent=Math.round((o*s-i.value)*1/(o*s)*100),e.absolute=o*s-i.value,e.amount=l-i.value;break}return e}price(t,i=!0){return this.rule?i?this.money(this.selectedVariant.price-this.discount(t).amount-this.selectedVariant.price*(this.rule.discountAmount/100)):this.selectedVariant.price-this.discount(t).amount-this.selectedVariant.price*(this.rule.discountAmount/100):i?this.money(this.selectedVariant.price-this.discount(t).amount):this.selectedVariant.price-this.discount(t).amount}updateForm(){let t=this.querySelector("input[name=selling_plan]");t&&(t.value=this.selectedSellingPlan?this.selectedSellingPlan.id:"",t.dispatchEvent(new Event("change")))}updateURLParams(){const t=new URL(window.location.href);this.selectedSellingPlan?(t.searchParams.set("selling_plan",this.selectedSellingPlan.id),window.history.replaceState({},"",t.href)):(t.searchParams.delete("selling_plan"),window.history.replaceState({},"",t.href))}addToCart(t){var e;const i=[{id:this.selectedVariant.id,quantity:t,...this.selectedSellingPlan&&{selling_plan:(e=this.selectedSellingPlan)==null?void 0:e.id}}];fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:i})}).then(s=>s.json()).then(s=>{this.log("Added item to cart: ",s);const n=new CustomEvent("skio::added-to-cart",{bubbles:!0,composed:!0,detail:{response:s,key:this.key}});this.dispatchEvent(n)}).catch(s=>{this.error(`SKIO ${this.key} error adding item to cart: `,s)})}}F(G,"properties",{key:{type:String},product:{type:Object},productHandle:{type:String},selectedVariant:{type:Object},options:{type:Object},quantity:{type:Number},rules:{type:Array},rule:{type:Object},cart:{type:Object},availableSellingPlanGroups:{state:!0},selectedSellingPlanGroup:{type:Object},selectedSellingPlan:{type:Object},disableUrl:{type:Boolean},debug:{type:Boolean},activatorLabel:{type:String},subscriptionTooltipText:{type:String}}),F(G,"styles",[Mt`
      :host {
        width: 100%;
        max-width: 440px;
      }

      .skio-plan-picker {
        display: flex;
        gap: 0.5rem;
        padding: 0;
        border: 0;
        font-size: 12px;
        color: black;
        width: 100%;
        margin-bottom: 1rem;
        font-family: inherit;
      }

      :host([layout="hidden"]) .skio-plan-picker {
        display: none;
      }

      :host([layout="vertical"]) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout="horizontal"]) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border: var(--skio-group-border-width, 1px) solid
          var(--skio-group-border-color, #ccc);
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-color: var(--skio-group-border-selected-color, #333);
        background-color: var(
          --skio-group-background-selected-color,
          transparent
        );
        color: var(--skio-group-text-selected-color, #000);
      }

      .group-container--last {
        order: 1;
      }

      :host([layout="horizontal"]) .group-container {
        width: calc(
          50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px))
        );
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      .group-input:focus-visible ~ .group-label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 10px;
        cursor: pointer;
      }

      .group-topline {
        display: flex;
        align-items: center;
        width: 100%;

        gap: 8px;
      }

      .group-container--selected .group-topline {
        font-weight: 700;
      }

      :host([layout="horizontal"]) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container {
        display: flex;
        color: var(--skio-group-border-color, #333);
      }

      .group-container--selected .skio-radio__container {
        color: var(--skio-group-border-selected-color, #333);
      }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }

      .skio-price {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        text-align: right;
        gap: 4px;

        line-height: 1;

        margin-left: auto;
        vertical-align: middle;

        font-weight: 500;
      }

      .skio-price s {
        font-size: 13px;

        font-weight: 400;
        opacity: 0.75;
      }

      :host([layout="horizontal"]) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition:
          max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-content.margin-left {
        margin-left: 25px;
      }

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout="horizontal"]) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout="horizontal"])
        .group-container:not(.group-container--selected)
        + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-title {
        width: 100%;
        max-width: 80%;
        line-height: 1.5;
      }

      :host([layout="horizontal"]) .group-title {
        max-width: 100%;
      }

      .savings {
        color: var(--skio-discount-text-color, #fff);
      }

      .savings.bubble {
        padding: 0px 8px;
        background-color: var(--skio-discount-color, #0fa573);
        border: 1px var(--skio-discount-color, #0fa573) solid;
        border-radius: 4px;
        font-size: 10px;
        color: var(--skio-discount-text-color, #fff);

        white-space: nowrap;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin-top: 5px;
        padding: 8px 30px 8px 10px;
        background-color: #f7f7f7;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(
          auto-fill,
          minmax(var(--skio-button-plan-selector-width, 20px), 1fr)
        );
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type="radio"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type="radio"]:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow:
          0 0 5px rgb(23 24 24 / 5%),
          0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(
            -55deg,
            #000,
            #000 20px,
            #ffb101 20px,
            #ffb101 40px
          )
          10;
      }

      .setupMode:after {
        content: "Setup Mode";
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

      #skio-plan-picker-legend {
        margin-block-end: var(--spacing-s);
        display: block;
        color: var(--color-black);
        font-weight: var(--weight-semi);
        font-family: var(--title-font);
        font-size: var(--font-size-m);
      }
    `]);customElements.get("skio-plan-picker")||customElements.define("skio-plan-picker",G);window&&(window.SkioPlanPicker=G);var p,at,J,ct,dt,pt,W,Z,D,O,H,Q,ut,ht,gt,A,E,mt,ft,bt,vt,_t;class Ft extends HTMLElement{constructor(){var t,i;super();$(this,p);this.product=null,this.sellingPlanGroups=null,this.sellingPlanAllocations=null,this.selectedSellingPlan=null,this.selectedVariant=null,this.subscription_usp=null,this.bundle_description=null,this.productFormId=null,this.productForm=null,this.offerOrder="subscription_first",this.sellingPlanInput=null,this.isSubscriptionPropertyInupt=null,this.subscribePanelContent=null,this.otpPanelContent=null,this.swatchesSubscribeForPlanTemplate=null,this.swatchesOnetimeForPlanTemplate=null,this.handleProductFormChange=e=>{if(e.target instanceof HTMLInputElement){const{name:s,value:n}=e.target;s==="id"&&this.handleVariantChange(parseInt(n)),s==="selling_plan"&&this.handleSellingPlanChange(parseInt(n))}},this.handleInternalChange=e=>{const s=e.target;s instanceof HTMLInputElement&&s.name==="selling-plan-group"&&this.handleSellingPlanGroupChange(s.value)},this.handleVariantChange=e=>{var n,l,o;const s=!!this.querySelector('input[name="selling-plan-group"][value="one-time"]:checked');if(this.selectedVariant=((n=this.product)==null?void 0:n.variants.find(r=>e===r.id))||null,this.sellingPlanAllocations=((l=this.selectedVariant)==null?void 0:l.selling_plan_allocations)||[],s)this.selectedSellingPlan=null;else if(this.sellingPlanAllocations.length>0){const r=(o=this.selectedSellingPlan)==null?void 0:o.id,a=r!=null?this.sellingPlanAllocations.find(u=>u.selling_plan_id===r):void 0,d=(a==null?void 0:a.selling_plan_id)??this.sellingPlanAllocations[0].selling_plan_id;this.selectedSellingPlan=this.getSelectedSellingPlan(d)}else this.selectedSellingPlan=null;this.updateSellingPlanInput(),this.render()},this.handleSellingPlanChange=e=>{this.selectedSellingPlan=this.getSelectedSellingPlan(e),this.updateSellingPlanInput(),this.render()},this.handleSellingPlanGroupChange=e=>{var s,n,l,o;if(e==="one-time")this.selectedSellingPlan=null;else{const r=(n=(s=this.sellingPlanGroups)==null?void 0:s.find(d=>d.id===e))==null?void 0:n.selling_plans;if(!r||r.length===0)return;const a=(o=(l=this.selectedVariant)==null?void 0:l.selling_plan_allocations.find(d=>d.selling_plan_group_id===e))==null?void 0:o.selling_plan_id;this.selectedSellingPlan=this.getSelectedSellingPlan(a||r[0].id)}this.updateSellingPlanInput(),this.render()},this.updateSellingPlanInput=()=>{if(!this.sellingPlanInput)return;const e=this.selectedSellingPlan?this.selectedSellingPlan.id.toString():"";this.sellingPlanInput.value=e,this.isSubscriptionPropertyInupt&&(this.isSubscriptionPropertyInupt.value=e===""?"false":"true");const s=new CustomEvent("selling-plan-changed",{detail:{sellingPlanId:e},bubbles:!0});this.dispatchEvent(s),this.dispatchPriceUpdateEvent()},this.getSelectedSellingPlan=e=>this.sellingPlanGroups&&this.sellingPlanGroups.flatMap(n=>n.selling_plans).find(n=>n.id===e)||null,this.dispatchPriceUpdateEvent=()=>{if(!this.selectedVariant||this.closest(".product-details__bundle-container [data-bundle-product-form]")!==null||!this.sellingPlanAllocations||this.sellingPlanAllocations.length===0)return;let e=this.selectedVariant.price,s=this.selectedVariant.compare_at_price;if(this.selectedSellingPlan&&this.selectedSellingPlan.price_adjustments.length>0){const l=this.selectedSellingPlan.price_adjustments[0];e=this.getDiscountedPrice(l.value_type,l.value,this.selectedVariant.price),s=this.selectedVariant.price}const n=new CustomEvent("selling-plan-price-update",{detail:{price:e,compareAtPrice:s,sellingPlan:this.selectedSellingPlan,variant:this.selectedVariant},bubbles:!0});this.dispatchEvent(n)},this.getSellingPlanAllocationsGroupIds=()=>{if(!this.sellingPlanAllocations||this.sellingPlanAllocations.length===0)return null;const e=[];for(const s of this.sellingPlanAllocations){const n=s.selling_plan_group_id;n&&!e.includes(n)&&e.push(n)}return e},this.getDiscountedPrice=(e,s,n)=>e==="percentage"?n-n*(s/100):e==="fixed_amount"?n-s:s,this.getDiscountString=(e,s,n)=>{const l=window.themeVars.strings.product.subscription_saving;if(e==="percentage"){const o=Math.floor(s/5)*5;return l.replace("{{ discount }}",`${o}%`)}else return e==="fixed_amount"?l.replace("{{ discount }}",k(s)):l.replace("{{ discount }}",k(n-s))},this.getFrequencyString=e=>{var n;const s=[((n=this.selectedSellingPlan)==null?void 0:n.name)??"",...c(this,p,ct).call(this)];for(const l of s){const o=c(this,p,J).call(this,l);if(o)return c(this,p,dt).call(this,o,e)}return""},this.getBundleDescription=()=>this.bundle_description||"",this.handleTooltipClick=e=>{const s=e.target,n=s.closest("[data-tooltip-close]");if(n){e.preventDefault(),e.stopPropagation();const o=n.getAttribute("data-tooltip-close"),r=this.querySelector(`[data-tooltip="${o}"]`);r&&r.classList.remove("is-visible");return}const l=s.closest("[data-tooltip-trigger]");if(l){e.preventDefault(),e.stopPropagation();const o=l.getAttribute("data-tooltip-trigger"),r=this.querySelector(`[data-tooltip="${o}"]`);r&&(this.querySelectorAll("[data-tooltip].is-visible").forEach(a=>{a.classList.remove("is-visible")}),r.classList.toggle("is-visible"))}},this.handleOutsideClick=e=>{e.target.closest("uwp-selling-plan-selector")||this.querySelectorAll("[data-tooltip].is-visible").forEach(n=>n.classList.remove("is-visible"))},this.renderSellingPlanGroup=e=>{if(!this.selectedVariant||!this.selectedVariant.price)return"";const s=this.selectedSellingPlan||e.selling_plans[0],n=this.selectedVariant.price,l=this.getDiscountedPrice(s.price_adjustments[0].value_type,s.price_adjustments[0].value,this.selectedVariant.price),o=!!this.selectedSellingPlan,r=c(this,p,ut).call(this),a=c(this,p,gt).call(this);return`
      <div class="selling-plan-selector__option-block">
        <label
          class="selling-plan-selector__option${o?" selling-plan-selector__option--active":""}"
          for="${e.id}"
        >
          <input
            id="${e.id}"
            class="selling-plan-selector__option-radio visually-hidden"
            type="radio"
            name="selling-plan-group"
            value="${e.id}"
            ${o?"checked":""}
          />
          <span class="selling-plan-selector__option-indicator"></span>
          <div class="selling-plan-selector__option-content">
            <div class="selling-plan-selector__option-title body-regular--kraftig">
              ${window.themeVars.strings.product.subscription_title}
            </div>
            <div class="selling-plan-selector__option-price">
              <span class="selling-plan-selector__option-compare-at-price body-regular--kraftig">
                ${k(n)}
              </span>
              <span class="selling-plan-selector__option-final-price body-regular--kraftig">
                ${k(l)}
              </span>
            </div>
          </div>
        </label>
        <div
          class="selling-plan-selector__option-dropdown"
          ${o?"":'style="display:none"'}
        >
          ${o&&r?`
              ${Array.isArray(this.subscription_usp)&&this.bundle_description?`<div class="selling-plan-selector__bundle-description body-xsmall--buch">${this.getBundleDescription()}</div>`:""}
              <div>
                ${c(this,p,ht).call(this)}
                ${a!==""?`<div class="selling-plan-selector__usp body-xsmall--buch">${a}</div>`:""}
              </div>
            `:""}
          <div
            class="selling-plan-selector__embedded-swatches"
            data-swatches-plan-slot="subscribe"
          ></div>
          ${o&&this.selectedSellingPlan.options.length>1?`<div class="selling-plan-selector__options-container">${this.renderSellingPlanOptions(e)}</div>`:""}
          <div data-subscribe-panel-slot></div>
        </div>
      </div>
    `},this.renderSellingPlanOptions=e=>{const s=e.selling_plans,n=s.findIndex(o=>{var r;return o.id===((r=this.selectedSellingPlan)==null?void 0:r.id)}),l=this.selectedSellingPlan?e.selling_plans[n].options:null;return!l||l.length===0?"":`
      <label
        for="options-group-${e.id}"
        class="selling-plan-selector__frequency-label body-xsmall--buch"
      >
        ${window.themeVars.strings.product.subscription_frequency||"Frequency"}:
      </label>
      <select
        id="options-group-${e.id}"
        class="selling-plan-selector__options-select body-xsmall--buch"
      >
        ${l&&l.map((o,r)=>`
              <option
                value="${s[r].id}"
                ${r===n?"selected":""}
              >
                ${o.value}
              </option>
            `).join("")}
      </select>
    `},this.renderOneTimePurchase=()=>{if(!this.selectedVariant)return"";const e=this.selectedVariant.compare_at_price,s=this.selectedVariant.price,n=e&&e>s,l=!this.selectedSellingPlan;return`
      <div class="selling-plan-selector__option-block">
        <label
          class="selling-plan-selector__option${l?" selling-plan-selector__option--active":""}"
          for="oneTime"
        >
          <input
            id="oneTime"
            type="radio"
            class="selling-plan-selector__option-radio visually-hidden"
            name="selling-plan-group"
            value="one-time"
            ${l?"checked":""}
          />
          <span class="selling-plan-selector__option-indicator"></span>
          <div class="selling-plan-selector__option-content">
            <div class="selling-plan-selector__option-title body-regular--kraftig">
              ${window.themeVars.strings.product.one_time_title}
            </div>
            <div class="selling-plan-selector__option-price">
              ${n?`<span class="selling-plan-selector__option-compare-at-price body-regular--kraftig">${k(e)}</span>`:""}
              <span class="selling-plan-selector__option-final-price body-regular--kraftig">
                ${k(s)}
              </span>
            </div>
          </div>
        </label>
        <div
          class="selling-plan-selector__option-dropdown"
          ${l?"":'style="display:none"'}
        >
          <div
            class="selling-plan-selector__embedded-swatches"
            data-swatches-plan-slot="onetime"
          ></div>
          <div data-otp-panel-slot></div>
        </div>
      </div>
    `},this.render=()=>{var u,f,y,m;let e=this.querySelector("[js-selling-plan-groups]");e||(e=document.createElement("div"),e.setAttribute("js-selling-plan-groups",""),e.classList.add("selling-plan-selector__groups-wrapper"),this.appendChild(e));const s=this.getSellingPlanAllocationsGroupIds(),n=this.closest(".product-details__bundle-container [data-bundle-product-form]")!==null;if(!this.sellingPlanAllocations||this.sellingPlanAllocations.length===0||!this.sellingPlanGroups||!s){n||(this.style.display="none"),this.setAttribute("data-subscription-available","false"),this.sellingPlanInput&&(this.sellingPlanInput.value=""),this.isSubscriptionPropertyInupt&&(this.isSubscriptionPropertyInupt.value="false"),this.updateBundleSubscriptionSelector();return}const o=this.sellingPlanGroups.filter(v=>s.includes(v.id)).map(v=>this.renderSellingPlanGroup(v)).join(""),r=this.renderOneTimePurchase();e.innerHTML=this.offerOrder==="one_time_first"?`${r}${o}`:`${o}${r}`;const a=e.querySelector('[data-swatches-plan-slot="subscribe"]');a&&((u=this.swatchesSubscribeForPlanTemplate)!=null&&u.content)&&(a.replaceChildren(),a.appendChild(this.swatchesSubscribeForPlanTemplate.content.cloneNode(!0)));const d=e.querySelector('[data-swatches-plan-slot="onetime"]');if(d&&((f=this.swatchesOnetimeForPlanTemplate)!=null&&f.content)&&(d.replaceChildren(),d.appendChild(this.swatchesOnetimeForPlanTemplate.content.cloneNode(!0))),this.subscribePanelContent){const v=e.querySelector("[data-subscribe-panel-slot]");v&&v.appendChild(this.subscribePanelContent)}if(this.otpPanelContent){const v=e.querySelector("[data-otp-panel-slot]");v&&v.appendChild(this.otpPanelContent)}c(this,p,bt).call(this),c(this,p,_t).call(this,e),c(this,p,vt).call(this),n||this.style.display==="none"&&(this.style.display=""),this.setAttribute("data-subscription-available","true"),this.updateBundleSubscriptionSelector(),this.dispatchPriceUpdateEvent(),(m=(y=this.productForm)==null?void 0:y.querySelector("uwp-product-swatches[data-embed-selling-plan-panels]"))==null||m.dispatchEvent(new CustomEvent("swatches-embed-refreshed",{bubbles:!0}))};try{this.product=JSON.parse(this.getAttribute("product")||"null"),this.sellingPlanGroups=((t=this.product)==null?void 0:t.selling_plan_groups)||null,this.selectedSellingPlan=JSON.parse(this.getAttribute("selected-selling-plan")||"null"),this.selectedVariant=JSON.parse(this.getAttribute("selected-variant")||"null"),this.sellingPlanAllocations=((i=this.selectedVariant)==null?void 0:i.selling_plan_allocations)||[],this.subscription_usp=JSON.parse(this.getAttribute("subscription-usp")||"[]"),this.bundle_description=this.getAttribute("bundle-description")||null,this.productFormId=this.getAttribute("product-form-id")||null,this.offerOrder=this.getAttribute("offer-order")==="one_time_first"?"one_time_first":"subscription_first",this.offerOrder==="one_time_first"&&(this.selectedSellingPlan=null)}catch{this.product=null,this.sellingPlanGroups=[],this.selectedSellingPlan=null,this.selectedVariant=null,this.sellingPlanAllocations=[],this.subscription_usp=[],this.bundle_description=null,this.productFormId=null,this.offerOrder="subscription_first"}}connectedCallback(){var n;this.sellingPlanInput=this.querySelector("[js-selling-plan-input]"),this.productForm=document.getElementById(this.productFormId||""),this.isSubscriptionPropertyInupt=(n=this.productForm)==null?void 0:n.querySelector("input[name='properties[_is_subscription]']");const t=this.querySelector("[data-subscribe-panel-content]");t&&(this.subscribePanelContent=t,t.remove());const i=this.querySelector("[data-otp-panel-content]");i&&(this.otpPanelContent=i,i.remove());const e=this.querySelector("template[data-swatches-subscribe-for-plan]");e&&(this.swatchesSubscribeForPlanTemplate=e.cloneNode(!0),e.remove());const s=this.querySelector("template[data-swatches-onetime-for-plan]");s&&(this.swatchesOnetimeForPlanTemplate=s.cloneNode(!0),s.remove()),this.render(),this.productForm&&this.productForm.addEventListener("change",this.handleProductFormChange),this.addEventListener("change",this.handleInternalChange),this.isSubscriptionPropertyInupt&&(this.isSubscriptionPropertyInupt.value=this.selectedSellingPlan?"true":"false"),this.addEventListener("click",this.handleTooltipClick,!0),document.addEventListener("click",this.handleOutsideClick)}static get observedAttributes(){return["selected-variant","selected-selling-plan"]}attributeChangedCallback(t,i,e){var s;e!==i&&(t==="selected-variant"?(this.selectedVariant=JSON.parse(e),this.sellingPlanAllocations=((s=this.selectedVariant)==null?void 0:s.selling_plan_allocations)||[]):t==="selected-selling-plan"&&(this.selectedSellingPlan=JSON.parse(e)),this.render())}disconnectedCallback(){this.removeEventListener("click",this.handleTooltipClick,!0),this.removeEventListener("change",this.handleInternalChange),document.removeEventListener("click",this.handleOutsideClick)}updateBundleSubscriptionSelector(){const t=document.querySelectorAll("uwp-selling-plan-selector"),i=document.querySelector(".bundle-subscription-selector");if(!i)return;let e=!0;t.forEach(s=>{if(s.closest(".bundle-subscription-selector"))return;s.getAttribute("data-subscription-available")==="true"&&(e=!1)}),e?i.setAttribute("data-subscription-available","false"):i.setAttribute("data-subscription-available","true"),i.style.display=""}}p=new WeakSet,at=function(t){const i=t.toLowerCase();return i.startsWith("week")?"week":i.startsWith("month")?"month":i.startsWith("day")?"day":null},J=function(t){const i=(t==null?void 0:t.trim())??"";if(!i)return null;const e=[/\bevery\s+(\d+)\s*(day|days|week|weeks|month|months)\b/i,/\b(\d+)\s*(day|days|week|weeks|month|months)\b/i];for(const s of e){const n=i.match(s);if(!n)continue;const l=c(this,p,at).call(this,n[2]);if(l)return{count:parseInt(n[1],10),unit:l}}return null},ct=function(){const t=this.selectedVariant;if(!t)return[];const i=[];for(const e of[t.option1,t.option2,t.option3]){const s=(e==null?void 0:e.toString().trim())??"";s.length>0&&i.push(s)}return i},dt=function(t,i){let e="";if(i==="Days"){switch(t.unit){case"day":e=t.count.toString();break;case"week":e=(t.count*7).toString();break;case"month":e=(t.count*30).toString();break}return`${e} ${i.toLowerCase()}`}switch(t.unit){case"day":e=(t.count/30).toFixed(2);break;case"week":e=(t.count*7/30).toFixed(2);break;case"month":e=t.count.toString();break}return e==="1"?"month":`${e} ${i.toLowerCase()}`},pt=function(t,i=""){for(const e of[t,i]){const s=c(this,p,J).call(this,e);if(!s)continue;const n=s.unit==="day"?"days":s.unit==="week"?"weeks":"months";return`every ${s.count} ${n}`}return t.trim()},W=function(){return`tooltip-${Math.random().toString(36).substring(2,11)}`},Z=function(t){return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},D=function(){return!this.subscription_usp||Array.isArray(this.subscription_usp)?null:this.subscription_usp},O=function(){var t,i;return!!((i=(t=c(this,p,D).call(this))==null?void 0:t.usp)!=null&&i.includes("[info]"))},H=function(){const t=c(this,p,D).call(this);if(!t)return!1;const i=n=>n.replace(/<[^>]+>/g," ").replace(/\s+/g," ").trim(),e=i((t.tooltip_title??"").toString()),s=i((t.tooltip_content??"").toString());return!!(e||s)},Q=function(t){const i=c(this,p,D).call(this);if(!i)return"";const e=i.tooltip_title||"",s=i.tooltip_content||"",n=c(this,p,Z).call(this,e);return`
        <span class="selling-plan-selector__info-icon" data-tooltip-trigger="${t}">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.52654 5.13545V4.375H7.40154V5.13545H6.52654ZM7.36583 5.80084V9.625H6.56226V5.80084H7.36583Z" fill="#767676"/>
            <circle cx="7" cy="7" r="6.5" stroke="#767676"/>
          </svg>
        </span>
        <div class="selling-plan-selector__tooltip" data-tooltip="${t}">
          <button class="selling-plan-selector__tooltip-close" data-tooltip-close="${t}">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${e?`<div class="selling-plan-selector__tooltip-title body-xsmall--kraftig">${n}</div>`:""}
          <div class="selling-plan-selector__tooltip-content body-xsmall--buch">
            ${s}
          </div>
        </div>
      `},ut=function(){if(!this.subscription_usp)return!1;if(Array.isArray(this.subscription_usp))return this.subscription_usp.length>0;const t=this.subscription_usp,i=!!(t.usp&&t.usp.trim()!==""),e=!!(t.title&&t.title.trim()!==""),s=c(this,p,H).call(this)&&!c(this,p,O).call(this)&&e;return i||e||s},ht=function(){if(Array.isArray(this.subscription_usp)||!this.subscription_usp)return"";const i=(this.subscription_usp.title??"").trim(),e=c(this,p,H).call(this)&&!c(this,p,O).call(this)&&!!i;if(!i&&!e)return"";const s=c(this,p,W).call(this),n=e?c(this,p,Q).call(this,s):"";return`
      <div class="selling-plan-selector__usp-title-row body-xsmall--kraftig">
        ${i?`<span class="selling-plan-selector__usp-title-text">${c(this,p,Z).call(this,i)}</span>`:""}
        ${n}
      </div>
    `},gt=function(){var l,o,r;if(!this.selectedSellingPlan||!this.subscription_usp)return"";const t=this.getDiscountString((l=this.selectedSellingPlan)==null?void 0:l.price_adjustments[0].value_type,(o=this.selectedSellingPlan)==null?void 0:o.price_adjustments[0].value,((r=this.selectedVariant)==null?void 0:r.price)||0);if(Array.isArray(this.subscription_usp))return`<ul>${this.subscription_usp.map(d=>{let u=d.replace("[discount]",t);const f=this.getFrequencyString("Days");return u=u.replace("[frequency]",f),`<li>${u}</li>`}).join("")}</ul>`;const i=this.subscription_usp.usp??"";if(!i.trim())return"";let e=i.replace("[discount]",t);const s=document.body.dataset.frequencyUnit||"Days",n=this.getFrequencyString(s);if(e=e.replace("[frequency]",n),c(this,p,O).call(this))if(c(this,p,H).call(this)){const a=c(this,p,W).call(this);e=e.replace("[info]",c(this,p,Q).call(this,a))}else e=e.replace("[info]","");return e},A=function(t){var i;if(t.hidden)return!1;if(t.matches("img, picture, svg, button, a, input, select, textarea, video, iframe")||(i=t.textContent)!=null&&i.trim())return!0;for(const e of Array.from(t.children))if(e instanceof HTMLElement&&c(this,p,A).call(this,e))return!0;return!1},E=function(t){if(!t.hasChildNodes())return!1;for(const i of Array.from(t.children))if(!(!(i instanceof HTMLElement)||i.hidden)&&c(this,p,A).call(this,i))return!0;return!1},mt=function(t){for(const i of Array.from(t.children))if(!(!(i instanceof HTMLElement)||i.hidden)){if(i.classList.contains("selling-plan-selector__embedded-swatches")){if(c(this,p,A).call(this,i))return!0;continue}if(i.matches("[data-otp-panel-slot], [data-subscribe-panel-slot]")){if(c(this,p,E).call(this,i))return!0;continue}if(i.classList.contains("selling-plan-selector__options-container")){if(i.querySelector("select"))return!0;continue}if(c(this,p,A).call(this,i))return!0}return!1},ft=function(){const t=this.selectedVariant;if(!t)return[];const i=[];for(const e of[t.option1,t.option2,t.option3]){const s=(e==null?void 0:e.toString().trim().toLowerCase())??"";s.length>0&&!i.includes(s)&&i.push(s)}return i},bt=function(){var e,s;if(!this.otpPanelContent)return;const t=this.otpPanelContent.querySelector("[data-otp-variant-descriptions]");if(!t)return;const i=((s=(e=this.selectedVariant)==null?void 0:e.id)==null?void 0:s.toString())??"";t.querySelectorAll("[data-variant-id]").forEach(n=>{const l=n;l.hidden=l.getAttribute("data-variant-id")!==i})},vt=function(){var l,o,r,a,d,u,f,y;if(!this.subscribePanelContent)return;const t=c(this,p,ft).call(this),i=((a=(r=(o=(l=window.themeVars)==null?void 0:l.strings)==null?void 0:o.product)==null?void 0:r.youth_system)==null?void 0:a.plan_frequency)??"",e=((y=(f=(u=(d=window.themeVars)==null?void 0:d.strings)==null?void 0:u.product)==null?void 0:f.youth_system)==null?void 0:y.per_month)??"";let s=0;this.subscribePanelContent.querySelectorAll("[data-addon-future-variant-rows]").forEach(m=>{const v=m.getAttribute("data-addon-future-variant-rows");if(!v)return;let S;try{S=JSON.parse(v)}catch{return}if(!Array.isArray(S)||S.length===0)return;let w=S[0];if(t.length>0){const C=S.find(L=>{const T=L.title.toLowerCase();return t.some(M=>T.includes(M))});C&&(w=C)}s+=w.price;const P=m.querySelector(".js-future-shipment-frequency");if(P){const C=c(this,p,pt).call(this,w.planName,w.title);P.textContent=C?i.replace(/\{\{\s*frequency\s*\}\}/,C):""}const x=m.querySelector(".js-future-shipment-price");x&&(x.textContent=`+ ${k(w.price)}${e}`)});const n=this.subscribePanelContent.querySelector(".js-future-shipment-subtotal");n&&(n.textContent=k(s))},_t=function(t){const i=t.querySelector("[data-otp-panel-slot]");i&&(i.hidden=!c(this,p,E).call(this,i));const e=t.querySelector("[data-subscribe-panel-slot]");e&&(e.hidden=!c(this,p,E).call(this,e)),t.querySelectorAll(".selling-plan-selector__embedded-swatches").forEach(s=>{var a;const n=s;if(!n.closest(".selling-plan-selector__option-dropdown"))return;n.hidden=!c(this,p,A).call(this,n);let o=n.nextElementSibling,r=!1;for(;o;){if(o instanceof HTMLElement&&o.hidden){o=o.nextElementSibling;continue}if(o.matches("[data-otp-panel-slot], [data-subscribe-panel-slot]")){c(this,p,E).call(this,o)&&(r=!0);break}if(o.matches(".selling-plan-selector__options-container")&&o.querySelector("select")){r=!0;break}const d=o;if((a=d.textContent)!=null&&a.trim()||d.querySelector("img, picture, svg, button, a, input, select, textarea, video, iframe")){r=!0;break}o=o.nextElementSibling}n.classList.toggle("selling-plan-selector__embedded-swatches--flush",!r)}),t.querySelectorAll(".selling-plan-selector__option-dropdown").forEach(s=>{const n=s;n.hidden=!c(this,p,mt).call(this,n)})};customElements.get("uwp-selling-plan-selector")||customElements.define("uwp-selling-plan-selector",Ft);var V,q,h,yt,K,Y,N,wt,j,z,St,X,Pt,kt,Ct,xt,At,$t,tt,et,It,Et,Vt;class Dt extends HTMLElement{constructor(){super();$(this,h);$(this,V);$(this,q);this._productData=null,this._productComponent=null,this._variantInputElement=null,this._swatchesForm=null,this._vectonCategory1Prop=null,this._vectonCategory2Prop=null,this._vectonCategory3Prop=null,this._splitItElement=null,R(this,V,t=>{c(this,h,wt).call(this,t)}),R(this,q,t=>{const i=t.target;i instanceof HTMLInputElement&&(i.name!=="selling-plan-group"||i.value!=="one-time"||c(this,h,N).call(this))})}static get observedAttributes(){return["product"]}connectedCallback(){setTimeout(()=>{var t,i,e,s,n;this._productComponent=document.querySelector("uwp-product"),this._variantInputElement=this.querySelector("[data-variant-input]"),this._swatchesForm=this.closest("form"),this._splitItElement=(t=this._swatchesForm)==null?void 0:t.querySelector("spt-one-liner"),this._vectonCategory1Prop=(i=this._swatchesForm)==null?void 0:i.querySelector("[name='properties[_dl_item_category_1]']"),this._vectonCategory2Prop=(e=this._swatchesForm)==null?void 0:e.querySelector("[name='properties[_dl_item_category_2]']"),this._vectonCategory3Prop=(s=this._swatchesForm)==null?void 0:s.querySelector("[name='properties[_dl_item_category_3]']"),!(!this._productComponent||!this._variantInputElement)&&(this.parseProductData(),this.setupEventListeners(),this.addEventListener("swatches-embed-refreshed",()=>{c(this,h,Y).call(this)}),(n=this._swatchesForm)==null||n.addEventListener("selling-plan-changed",()=>{c(this,h,Y).call(this)}),this.preselectOptions(),c(this,h,N).call(this))},0)}attributeChangedCallback(t,i,e){t==="product"&&e!==i&&this.parseProductData()}parseProductData(){const t=this.getAttribute("product");t&&(this._productData=JSON.parse(t))}setupEventListeners(){var i,e;this.querySelectorAll(".product-swatches__select").forEach(s=>{s.addEventListener("change",this.onSelectChange.bind(this))}),(i=this._swatchesForm)==null||i.addEventListener("click",U(this,V)),(e=this._swatchesForm)==null||e.addEventListener("change",U(this,q))}onSelectChange(){this.updateSelectedOptions()}getSelectValues(){const t=this.querySelectorAll(".product-swatches__select");return Array.from(t).map(i=>i.value)}findVariant(t){if(this._productData)return this._productData.variants.find(i=>t.every((e,s)=>i.options[s]===e))}refreshSwatchPresentation(){var l,o;if(!this._productData||!this.querySelector(".product-swatches--card-picker"))return;const t=this.getSelectValues(),i=((l=this._productData.variants[0])==null?void 0:l.options.length)??0;if(t.length!==i)return;const e=c(this,h,j).call(this);c(this,h,Et).call(this,t);const s=(o=this._swatchesForm)==null?void 0:o.querySelectorAll(".product-swatches--card-picker .product-swatches__option");s==null||s.forEach(r=>{var P;const a=r,d=Number(a.getAttribute("data-option-index")),u=a.getAttribute("data-option-value");if(u===null||Number.isNaN(d))return;const f=[...t];f[d]=u;const y=c(this,h,z).call(this,f,e),m=y!=null,v=c(this,h,X).call(this,d,u,t,e);if(a.classList.toggle("product-swatches__option--hidden",v),a.toggleAttribute("hidden",v),v){a.classList.remove("selected"),a.setAttribute("aria-pressed","false"),a.setAttribute("aria-hidden","true"),a.setAttribute("aria-disabled","true"),a.tabIndex=-1;return}if(a.removeAttribute("aria-hidden"),a.tabIndex=0,!m){a.classList.remove("selected"),a.setAttribute("aria-pressed","false"),a.setAttribute("aria-disabled","true"),a.classList.add("product-swatches__option--unavailable");return}const S=t[d]===u;a.classList.toggle("selected",S),a.setAttribute("aria-pressed",S?"true":"false"),a.setAttribute("data-variant-id",y.id),a.classList.toggle("product-swatches__option--unavailable",!y.available),y.available?a.removeAttribute("aria-disabled"):a.setAttribute("aria-disabled","true");const w=a.querySelector(".product-swatches__option-price");if(w){const x=(P=a.closest("[data-swatches-panel]"))==null?void 0:P.getAttribute("data-swatches-panel");c(this,h,It).call(this,w,c(this,h,$t).call(this,y,x??null))}});const n=this.findVariant(t);if(n){const r=this.querySelector("[data-variant-price-telemetry]"),a=this.querySelector("[data-variant-telemetry]");r&&(r.textContent=k(n.price)),a&&a.setAttribute("data-variant-telemetry",n.id)}}updateSelectedOptions(){var l,o,r;if(!this._productData)return;const t=this._productComponent;if(!t)return;let i=this.getSelectValues();const e=((l=this._productData.variants[0])==null?void 0:l.options.length)??0;if(i.length!==e)return;const s=c(this,h,Pt).call(this,i);s.every((a,d)=>a===i[d])||(c(this,h,kt).call(this,s),i=s);const n=this.findVariant(i);if(!(!n||!this._productComponent)){if(t.setSelectedVariantId(n.id),(o=this._variantInputElement)==null||o.setAttribute("value",n.id),(r=this._variantInputElement)==null||r.dispatchEvent(new Event("change",{bubbles:!0})),this.updateVectonCategoryLineProperties("properties[_dl_item_category_1]",this._vectonCategory1Prop,n.dlCategory1),this.updateVectonCategoryLineProperties("properties[_dl_item_category_2]",this._vectonCategory2Prop,n.dlCategory2),this.updateVectonCategoryLineProperties("properties[_dl_item_category_3]",this._vectonCategory3Prop,n.dlCategory3),this._splitItElement){const a=Number(n.price)/100,d=this._productData.showInstalments||!1;this._splitItElement.setAttribute("amount",String(a)),d?this._splitItElement.removeAttribute("hidden"):this._splitItElement.setAttribute("hidden",String(!0))}c(this,h,Vt).call(this,Number(n.price)),this.refreshSwatchPresentation()}}updateVectonCategoryLineProperties(t,i,e){i&&(i.setAttribute("value",`${e||""}`),e?i.setAttribute("name",t):i.removeAttribute("name"))}preselectOptions(){var s;const i=new URLSearchParams(window.location.search).get("variant");if(i&&this._productData){const n=this._productData.variants.find(l=>l.id==i);if(n){this.selectVariantOptions(n.options);return}}const e=(s=this._productData)==null?void 0:s.variants[0];e&&this.selectVariantOptions(e.options)}selectVariantOptions(t){const i=this.querySelectorAll(".product-swatches__select");t.forEach((e,s)=>{const n=i[s];n&&Array.from(n.options).find(o=>o.value===e)&&(n.value=e)}),this.updateSelectedOptions()}}V=new WeakMap,q=new WeakMap,h=new WeakSet,yt=function(t){return t.onlySubscriptions!==!0},K=function(){return this._productData?this._productData.variants.filter(t=>c(this,h,yt).call(this,t)):[]},Y=function(){c(this,h,N).call(this),this.refreshSwatchPresentation()},N=function(){var r,a;if(!this._productData||!((r=this._swatchesForm)==null?void 0:r.querySelector('input[name="selling-plan-group"][value="one-time"]:checked')))return;const i=c(this,h,K).call(this);if(i.length===0)return;const e=((a=this._productData.variants[0])==null?void 0:a.options.length)??0,s=this.getSelectValues();if(s.length!==e)return;const n=[...s];for(let d=0;d<e;d++){const u=new Set(i.map(f=>f.options[d]).filter(f=>f!=null&&f!==""));if(!u.has(n[d])){const f=this.querySelector(`.product-swatches__select[data-option-index="${d}"]`),m=Array.from((f==null?void 0:f.options)??[]).map(v=>v.value).find(v=>u.has(v));m&&(n[d]=m)}}if(!i.some(d=>n.every((u,f)=>d.options[f]===u))){const d=i[0].options;for(let u=0;u<e;u++)n[u]=d[u]??n[u]}if(!n.every((d,u)=>d===s[u])){for(let d=0;d<e;d++){const u=this.querySelector(`.product-swatches__select[data-option-index="${d}"]`);u&&u.value!==n[d]&&(u.value=n[d])}this.updateSelectedOptions()}},wt=function(t){var l,o;if(!((l=this._swatchesForm)!=null&&l.contains(this)))return;const i=(o=t.target)==null?void 0:o.closest(".product-swatches__option");if(!i||!this._swatchesForm.contains(i))return;const e=i.getAttribute("data-option-index");if(e===null)return;const s=this.querySelector(`.product-swatches__select[data-option-index="${e}"]`);if(!s)return;const n=i.getAttribute("data-option-value");n!==null&&(s.value=n,s.dispatchEvent(new Event("change",{bubbles:!0})))},j=function(){var i;return this._productData?((i=this._swatchesForm)==null?void 0:i.querySelector('input[name="selling-plan-group"][value="one-time"]:checked'))?c(this,h,K).call(this):this._productData.variants:[]},z=function(t,i){return i.find(e=>t.every((s,n)=>e.options[n]===s))},St=function(t,i,e,s){return s.some(n=>n.options[t]===i&&e.slice(0,t).every((l,o)=>n.options[o]===l))},X=function(t,i,e,s){return!c(this,h,St).call(this,t,i,e,s)},Pt=function(t){var n;if(!this._productData)return t;const i=c(this,h,j).call(this),e=((n=this._productData.variants[0])==null?void 0:n.options.length)??0;if(t.length!==e||i.length===0)return t;const s=[...t];for(let l=0;l<e;l++){const o=new Set(i.filter(r=>s.slice(0,l).every((a,d)=>r.options[d]===a)).map(r=>r.options[l]).filter(r=>r!=null&&r!==""));if(!o.has(s[l])){const r=this.querySelector(`.product-swatches__select[data-option-index="${l}"]`),d=Array.from((r==null?void 0:r.options)??[]).map(u=>u.value).find(u=>o.has(u))??[...o][0];d&&(s[l]=d)}}if(!c(this,h,z).call(this,s,i)){const l=i[0];if(l)for(let o=0;o<e;o++)s[o]=l.options[o]??s[o]}return s},kt=function(t){var s,n;const i=((n=(s=this._productData)==null?void 0:s.variants[0])==null?void 0:n.options.length)??0;let e=!1;for(let l=0;l<i;l++){const o=this.querySelector(`.product-swatches__select[data-option-index="${l}"]`);o&&o.value!==t[l]&&(o.value=t[l],e=!0)}return e},Ct=function(){var e,s;const t=(e=this._swatchesForm)==null?void 0:e.querySelector("input[js-selling-plan-input], input[name='selling_plan']"),i=(s=t==null?void 0:t.value)==null?void 0:s.trim();return i||null},xt=function(t,i){const e=t.selling_plan_allocations;if(!e||e.length===0)return null;if(i){const s=e.find(n=>String(n.selling_plan_id)===String(i));if(s)return s}return e[0]??null},At=function(){var t;return((t=this._swatchesForm)==null?void 0:t.querySelector('input[name="selling-plan-group"][value="one-time"]:checked'))!=null},$t=function(t,i){return i==="subscribe"?c(this,h,tt).call(this,t):i==="onetime"?c(this,h,et).call(this,t):c(this,h,At).call(this)?c(this,h,et).call(this,t):c(this,h,tt).call(this,t)},tt=function(t){const i=c(this,h,Ct).call(this),e=c(this,h,xt).call(this,t,i),s=Number(t.price);if(!e){const r=s;let a=null;const d=t.compare_at_price;if(d!=null&&d!==""){const u=Number(d);!Number.isNaN(u)&&u>r&&(a=u)}return{compareAt:a!=null&&a>r?a:null,finalPrice:s}}const n=Number(e.price);let l=s;const o=e.compare_at_price;if(o!=null){const r=Number(o);!Number.isNaN(r)&&r>n&&(l=r)}return{compareAt:l>n?l:null,finalPrice:n}},et=function(t){const i=Number(t.price),e=t.compare_at_price,s=e!=null&&e!==""?Number(e):null;return{compareAt:s!=null&&!Number.isNaN(s)&&s>i?s:null,finalPrice:i}},It=function(t,i){t.replaceChildren();const{compareAt:e,finalPrice:s}=i;if(e!=null&&!Number.isNaN(e)&&e>s){const l=document.createElement("span");l.className="selling-plan-selector__option-compare-at-price body-xsmall--kraftig",l.textContent=k(e),t.appendChild(l)}const n=document.createElement("span");n.className="selling-plan-selector__option-final-price body-xsmall--kraftig",n.textContent=k(s),t.appendChild(n)},Et=function(t){const i=c(this,h,j).call(this),e=this.querySelectorAll(".product-swatches__select");for(const s of e){const n=Number(s.dataset.optionIndex);if(!Number.isNaN(n))for(const l of Array.from(s.options)){const o=[...t];o[n]=l.value;const r=c(this,h,z).call(this,o,i)!=null,a=c(this,h,X).call(this,n,l.value,t,i);l.hidden=a,l.disabled=a||!r}}},Vt=function(t){var e,s,n;const i=(e=this._swatchesForm)==null?void 0:e.querySelectorAll("[data-affirm-trigger]");if(i!=null&&i.length){for(const l of i)l.setAttribute("data-amount",String(t));(n=(s=window.affirm)==null?void 0:s.ui)!=null&&n.ready&&window.affirm.ui.ready(()=>{var l,o,r;(r=(o=(l=window.affirm)==null?void 0:l.ui)==null?void 0:o.refresh)==null||r.call(o)})}};customElements.get("uwp-product-swatches")||customElements.define("uwp-product-swatches",Dt);const jt=()=>{const g=window.yotpo;if(typeof(g==null?void 0:g.refreshWidgets)=="function"){g.refreshWidgets();return}typeof(g==null?void 0:g.initWidgets)=="function"&&g.initWidgets()};export{jt as r};
